import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../../../core/services/auth.service';
import { TranslatePipe } from '@ngx-translate/core';
import {
  FormErrorDisplayComponent
} from '../../../../shared/components/form-validation-errors/form-error-display/form-error-display';
import {
  FormValidationErrorService
} from '../../../../shared/components/form-validation-errors/form-validation.service';
import { IconField } from 'primeng/iconfield';
import { InputText } from 'primeng/inputtext';
import { InputIcon } from 'primeng/inputicon';
import { Password } from 'primeng/password';
import { RegisterDto } from '../../../../core/api/_dtos/register.dto';
import { SsoButtonsComponent } from '../../sso-buttons/sso-buttons';
import { AppButton } from '../../../client/components/atom/app-button/app-button';

@Component({
  selector: 'app-register-form',
  templateUrl: './register-form.html',
  styleUrls: ['./register-form.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormErrorDisplayComponent,
    IconField,
    InputIcon,
    InputText,
    Password,
    TranslatePipe,
    SsoButtonsComponent,
    AppButton
  ]
})
export class RegisterForm implements OnInit, OnDestroy {
  @Output() success = new EventEmitter<void>();

  registerForm: FormGroup;
  loading = false;

  protected formValidation = inject(FormValidationErrorService);

  constructor(
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    this.registerForm = this.fb.group({
      name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.formValidation.registerForm(this.registerForm);
  }

  ngOnDestroy(): void {
    this.formValidation.unregisterForm();
  }

  onSubmit(): void {
    if (!this.registerForm.valid) {
      this.registerForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    this.registerForm.disable();
    const dto: RegisterDto = this.registerForm.value;
    this.authService.register(dto).subscribe({
      next: () => {
        this.success.emit();
      },
      error: () => {
        this.loading = false;
        this.registerForm.enable();
      }
    });
  }
}

